<section class="home-content" dir="{{languageDir}}">
  <ul class="breadcrumb">
    <li class="breadcrumb-item" *ngFor="let breadcrumItem of breadcrumList">
      <a class="breadcrumb-link" [routerLink]="breadcrumItem.Url" [id]="breadcrumItem.id"
        (click)="DisplayRightmenu(breadcrumItem.id, breadcrumItem.Url)">{{lang.getTransalatedValue(breadcrumItem.text)}}</a>
    </li>
  </ul>
  <mat-card class="master-card">
    <div class="p-grid p-fluid">
      <div class="p-col-12 p-md-6 p-lg-7 p-xl-7">
        <mat-card-title class="master-title">{{langObj ? langObj?.MasterDataSettings : ('MasterDataSettings' | translate)}}</mat-card-title>
      </div>

      <div class="p-col-12 p-md-6 p-lg-5 p-xl-5" style="display: flex; justify-content: flex-end;">
        <form [formGroup]="searchMasterForm" style="float: right;">
          <mat-form-field appearance="fill" class="field-fill-custom-master" style="margin-right: 10px;
          ">
            <mat-label class="required">{{langObj ? langObj?.Group : ('Group' | translate)}}</mat-label>
            <mat-select panelClass="testClass" name="group" formControlName="group" (selectionChange)="getPlantData()">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'TypeName'" [array]="groupList"
            (filteredReturn)="filteredModules = $event"></mat-select-filter>
              <mat-option *ngFor="let group of filteredModules" [value]="group.TypeId">{{group.TypeName}}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="fill" class="field-fill-custom-master">
            <mat-label class="required">{{langObj ? langObj?.Plant : ('Plant' | translate)}}</mat-label>
            <mat-select panelClass="testClass" name="plant" formControlName="plant" (selectionChange)="getMasterData()">
              <mat-select-filter [placeholder]="'Search'" [displayMember]="'DeptDesc'" [array]="plantList"
            (filteredReturn)="filteredModule = $event"></mat-select-filter>
              <mat-option *ngFor="let plant of filteredModule" [value]="plant.DeptId">{{plant.DeptDesc}}</mat-option>
            </mat-select>
          </mat-form-field>

        </form>
      </div>
    </div>
  </mat-card>
  <div class="p-mt-2 p-p-0">
    <!-- Table -->
    <div class="p-grid p-fluid">

      <!-- <div class="p-xl-6 p-lg-6 p-md-12 p-col-12">
        <app-general-department></app-general-department>
      </div> -->
      <div class="p-xl-12 p-lg-12 p-md-12  p-col-12">
        <app-general-area></app-general-area>
      </div>
      <!-- <div class="p-xl-6 p-lg-6 p-md-12  p-col-12">
        <app-general-shift></app-general-shift>
      </div> -->
    </div>
    <div class="p-grid p-fluid">

      <!-- <div class="p-xl-6 p-lg-6 p-md-12 p-col-12">
        <app-general-department></app-general-department>
      </div> -->
      <div class="p-xl-12 p-lg-12 p-md-12  p-col-12">
        <app-general-subDept></app-general-subDept>
      </div>

      <!-- <div class="p-xl-6 p-lg-6 p-md-12  p-col-12">
        <app-general-shift></app-general-shift>
      </div> -->
    </div>
  </div>
</section>